import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  changeTestReportStatusChange,
  handleAmenIntarnalCertificateCreateUpdate,
  handleIntarnalCertificateCreateUpdate,
  handleIntarnalCertificateValidate,
  handleSendVerifictionCodeForApprovel,
} from "../commonHandlerFunction/intenralCertificateHandlerFunction";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { decryptDataForURL, encryptDataForURL } from "../../../utills/useCryptoUtils";
import { CommonTMRoles, getCurrentRole, getDayCountFromDate, getUserDetails } from "../../../services/commonFunction";
import VerifyOTPModal from "../commonModalForms/VerifyOTPModal";
import { toast } from "react-toastify";
import CustomPopupModal from "../commonModalForms/CustomPopupModal";

export const selectUser = (state) => state.user;
const InternalCertificateButtons = ({
  action,
  tabOpen,
  setIsPopupOpen,
  setJRFCreationType,
  setInwardBtnchange,
  formData,
  subTableData,
  jrfId,
  viewOnly,
  handleSubmit,
  remarkText,
  setSaveClicked,
  formConfig,
  saveClicked,
  setIsRejectPopupOpen,
  handleBackButtonFunction,
  setIsOverlayLoader,
  isValideValue,
  setFormData
}) => {
  const { t } = useTranslation();
  let user;
  const session = useSelector((state) => state.session);
  user = session.user;
  const [isCustomPopupOTP, setIsCustomPopupOTP] = useState(false);
  const [isCustomPopup, setIsCustomPopup] = useState(false);
  let navigate = useNavigate();
  const translate = t;
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const is_amendment = decryptDataForURL(params.get("is_amendment"))
  const is_for_request = decryptDataForURL(params.get("is_for_request"))
  const is_show_testmemo = !is_amendment || (is_amendment && ['SFM', 'Both'].includes(formData[0]?.type_of_amnendment))
  const is_show_amend_testmemo = (is_amendment && ['SFM', 'Both'].includes(formData[0]?.type_of_amnendment))

  const handleVerifyApproval = () => {
    try {
      changeTestReportStatusChange(
        formData[0].ic_id,
        navigate,
        formData[0]?.status === "pending" && !is_amendment
          ? "dtm-approved"
          : "tm-approved",
        "",
        "",
        null,
        setIsPopupOpen,
        setIsOverlayLoader,
        formData,
        is_amendment
      )
    }
    finally {
      setIsCustomPopupOTP(false)
    }
  }
  const checkIsEnabled2FA = () => {
    if (getUserDetails()?.logged_in_user_info?.usr_certificate_approval_2fa) {
      handleSendVerifictionCodeForApprovel("generate", formData[0].ic_ulrno || formData[0].ic_test_report_no, "", setIsOverlayLoader, setIsCustomPopupOTP)
    }
    else {
      handleVerifyApproval()
    }
  }
  const handleCustomConfirmHandler = () => {
    handleAmenIntarnalCertificateCreateUpdate(
      handleSubmit,
      formData,
      navigate,
      "save",
      setIsOverlayLoader,
      subTableData
    )
  }
  const createddays = getDayCountFromDate(formData[0]?.ic_created_time, new Date())
  // const createddays = 29
  return (
    <div className="submit_btns">
      <VerifyOTPModal isCustomPopup={isCustomPopupOTP} setIsCustomPopup={setIsCustomPopupOTP} handleConfirm={handleVerifyApproval} certiId={formData[0].ic_ulrno || formData[0].ic_test_report_no} setIsOverlayLoader={setIsOverlayLoader} />
      {is_amendment ? <>
        <Button
          type="button"
          className="cancelBtn"
          id="submit_btn3"
          onClick={() => {
            navigate(-1)
          }}
        >
          {translate("common.backBtn")}
        </Button>
        {is_for_request ?
          <>
            <Button
              type="button"
              className="submitBtn"
              id="submit_btn1"
              disabled={!isValideValue}
              onClick={(e) =>
                setIsCustomPopup(true)
              }
            >
              Proceed with Amendment
            </Button>
          </>
          : action !== "view" ?
            [...CommonTMRoles, 'DTM'].includes(user?.role) ?
              <React.Fragment>
                <Button
                  type="button"
                  className="saveBtn"
                  id="submit_btn1"
                  onClick={(e) =>
                    navigate(
                      `/testReport/previewPDF/${encryptDataForURL(formData[0].ic_id)}` + "?ReferenceNo=" +
                      encryptDataForURL(formData[0]?.ic_refenence)
                    )
                  }
                >
                  {translate("common.previewBtn")}
                </Button>
                {is_amendment && <Button
                  type="button"
                  className="saveBtn"
                  id="submit_btn1"
                  onClick={(e) =>
                    navigate(
                      `/testReport/previewPDF/${encryptDataForURL(formData[0].ic_id)}` + "?ReferenceNo=" +
                      encryptDataForURL(formData[0]?.ic_refenence) + "&is_amendment=" + encryptDataForURL(true)
                    )
                  }
                >
                  Amend. Preview
                </Button>}
                <Button
                  type="button"
                  className="saveBtn"
                  id="submit_btn1"
                  onClick={(e) => setIsRejectPopupOpen(true)}
                >
                  Reject Amendment
                </Button>
                <Button
                  type="button"
                  className="submitBtn"
                  id="submit_btn1"
                  onClick={(e) =>
                    checkIsEnabled2FA()
                  }
                >
                  Accept Amendment
                </Button>
              </React.Fragment>
              :
              <>
                {!['SU'].includes(user?.role) && <button
                  type="button"
                  className="saveBtn"
                  id="submit_btn2"
                  data-name="save"
                  disabled={!isValideValue}
                  onClick={(e) =>
                    handleAmenIntarnalCertificateCreateUpdate(
                      handleSubmit,
                      formData,
                      navigate,
                      "save",
                      setIsOverlayLoader,
                      subTableData
                    )
                  }
                >
                  Save Amendment
                </button>}
                <Button
                  type="button"
                  className="submitBtn"
                  id="submit_btn1"
                  disabled={!isValideValue}
                  onClick={(e) =>
                    handleAmenIntarnalCertificateCreateUpdate(
                      handleSubmit,
                      formData,
                      navigate,
                      "post",
                      setIsOverlayLoader,
                      subTableData
                    )
                  }
                >
                  {['SU'].includes(user?.role) ? "Save" : "Submit Amendment"}
                </Button>
              </> : null
        }
      </> : action !== "view" ? (
        CommonTMRoles.includes(user?.role) ? (
          <React.Fragment>
            <Button
              type="button"
              className="cancelBtn"
              id="submit_btn3"
              onClick={() => {
                handleBackButtonFunction();
              }}
            >
              {translate("common.backBtn")}
            </Button>
            <Button
              type="button"
              className="saveBtn"
              id="submit_btn1"
              onClick={(e) =>
                navigate(
                  `/testReport/previewPDF/${encryptDataForURL(formData[0].ic_id)}` + "?ReferenceNo=" +
                  encryptDataForURL(formData[0]?.ic_refenence)
                )
              }
            >
              {translate("common.previewBtn")}
            </Button>
            <Button
              type="button"
              className="saveBtn"
              id="submit_btn1"
              onClick={(e) => setIsRejectPopupOpen(true)}
            >
              {translate("common.rejectBtn")}
            </Button>
            <Button
              type="button"
              className="submitBtn"
              id="submit_btn1"
              onClick={(e) =>
                checkIsEnabled2FA()
              }
            >
              {translate("common.acceptBtn")}
            </Button>
          </React.Fragment>
        ) : user?.role == "DTM" ? (
          <React.Fragment>
            <Button
              type="button"
              className="cancelBtn"
              id="submit_btn3"
              onClick={() => {
                handleBackButtonFunction();
              }}
            >
              {translate("common.backBtn")}
            </Button>
            <Button
              type="button"
              className="saveBtn"
              id="submit_btn1"
              onClick={(e) =>
                navigate(
                  `/testReport/previewPDF/${encryptDataForURL(formData[0].ic_id)}` + "?ReferenceNo=" +
                  encryptDataForURL(formData[0]?.ic_refenence)
                )
              }
            >
              {translate("common.previewBtn")}
            </Button>
            <Button
              type="button"
              className="saveBtn"
              id="submit_btn1"
              onClick={(e) => setIsRejectPopupOpen(true)}
            >
              {translate("common.rejectBtn")}
            </Button>
            <Button
              type="button"
              className="submitBtn"
              id="submit_btn1"
              onClick={(e) =>
                checkIsEnabled2FA()
              }
            >
              {translate("common.acceptBtn")}
            </Button>
          </React.Fragment>
        ) : formData?.[0]?.status === "tm-approved" ? (
          <React.Fragment>
            <Button
              type="button"
              className="cancelBtn"
              id="submit_btn3"
              onClick={() => {
                handleBackButtonFunction();
              }}
            >
              {translate("common.backBtn")}
            </Button>
            {formData?.[0]?.ic_id && (
              <Button
                type="button"
                className="saveBtn"
                id="submit_btn1"
                onClick={(e) =>
                  navigate(
                    `/testReport/previewPDF/${encryptDataForURL(formData[0].ic_id)}` + "?ReferenceNo=" +
                    encryptDataForURL(formData[0]?.ic_refenence)
                  )
                }
              >
                {translate("common.previewBtn")}
              </Button>
            )}
            <Button
              type="button"
              className="submitBtn"
              id="submit_btn1"
              onClick={(e) =>
                handleIntarnalCertificateValidate(
                  handleSubmit,
                  setIsPopupOpen,
                  setJRFCreationType,
                  "publish"
                )
              }
            >
              {translate("common.publishBtn")}
            </Button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Button
              type="button"
              className="cancelBtn"
              id="submit_btn3"
              onClick={() => {
                handleBackButtonFunction();
              }}
            >
              {translate("common.backBtn")}
            </Button>
            {getCurrentRole() != "SU" && <button
              type="button"
              className="saveBtn"
              id="submit_btn2"
              data-name="save"
              disabled={!isValideValue}
              onClick={(e) =>
                handleIntarnalCertificateValidate(
                  handleSubmit,
                  setIsPopupOpen,
                  setJRFCreationType,
                  "save"
                )
              }
            >
              {translate("common.saveBtn")}
            </button>}
            {formData?.[0]?.ic_id && (
              <Button
                type="button"
                className="saveBtn"
                id="submit_btn1"
                onClick={(e) => {
                  handleIntarnalCertificateCreateUpdate(
                    formData,
                    formData[0]?.fk_tmid,
                    navigate,
                    "save",
                    setIsOverlayLoader,
                    subTableData,
                    user,
                    setIsPopupOpen,
                    1,
                    () => {
                      navigate(
                        `/testReport/previewPDF/${encryptDataForURL(formData[0].ic_id)}` + "?ReferenceNo=" +
                        encryptDataForURL(formData[0]?.ic_refenence)
                      )
                    }
                  );
                }

                }
              >
                {translate("common.previewBtn")}
              </Button>
            )}
            <Button
              type="button"
              className="submitBtn"
              id="submit_btn1"
              disabled={!isValideValue}
              onClick={(e) =>
                handleIntarnalCertificateValidate(
                  handleSubmit,
                  setIsPopupOpen,
                  setJRFCreationType,
                  "post"
                )
              }
            >
              {translate("common.postBtn")}
            </Button>
          </React.Fragment>
        )
      ) : (
        <React.Fragment>
          <Button
            type="button"
            className="cancelBtn"
            id="submit_btn3"
            onClick={() => {
              handleBackButtonFunction();
            }}
          >
            {translate("common.backBtn")}
          </Button>
          {formData?.[0]?.ic_id && (
            <Button
              type="button"
              className="saveBtn"
              id="submit_btn1"
              onClick={(e) =>
                navigate(
                  `/testReport/previewPDF/${encryptDataForURL(formData[0].ic_id)}` + "?ReferenceNo=" +
                  encryptDataForURL(formData[0]?.ic_refenence)
                )
              }
            >
              {translate("common.previewBtn")}
            </Button>
          )}
        </React.Fragment>
      )}
      {is_show_testmemo && <Button
        type="button"
        className="saveBtn"
        id="submit_btn1"
        onClick={(e) =>
          navigate(
            `/testmemoList/testmemo?view=${encryptDataForURL(
              "view"
            )}&status=${encryptDataForURL(
              "testMemo"
            )}&testMemoId=${encryptDataForURL(formData[0]?.["fk_tmid"] || decryptDataForURL(params.get("testMemoId")))}`
          )
        }
      >
        View Test Memo
      </Button>}
      {is_show_amend_testmemo &&
        // ['LR'].includes(user?.role) && formData?.[0]?.ic_id &&
        (<Button
          type="button"
          className="saveBtn"
          id="submit_btn1"
          onClick={(e) =>
            navigate(
              `/testmemoList/testmemo?view=${encryptDataForURL(
                "view"
              )}&status=${encryptDataForURL(
                "testMemo"
              )}&testMemoId=${encryptDataForURL(formData[0]?.["fk_tmid"] || decryptDataForURL(params.get("testMemoId")))}&is_amendment=${encryptDataForURL(is_amendment)}`
            )
          }
        >
          View Amend. Test Memo
        </Button>)
      }
      {isCustomPopup && (
        <CustomPopupModal
          isCustomPopup={isCustomPopup}
          setIsCustomPopup={setIsCustomPopup}
          handleConfirm={() => handleCustomConfirmHandler()}
          formData={formData}
          setFormData={setFormData}
          section={{
            ...formConfig.sections[0]?.customField,
            fields: formConfig.sections[0]?.customField?.fields?.map((field) =>
              field.name === "type_of_amnendment"
                ? {
                  ...field,
                  options: createddays <= 30 ? ["Certificate", "SFM", "Both"] : ['Certificate']
                }
                : field
            ),
          }}
          filterMasterOptions={[]}
        />
      )}
    </div>
  );
};

InternalCertificateButtons.propTypes = {
  action: PropTypes.string,
  tabOpen: PropTypes.bool,
  setIsPopupOpen: PropTypes.func,
  setJRFCreationType: PropTypes.func,
  setInwardBtnchange: PropTypes.func,
  formData: PropTypes.object,
  subTableData: PropTypes.arrayOf(PropTypes.object),
  jrfId: PropTypes.string,
  viewOnly: PropTypes.bool,
  handleSubmit: PropTypes.func,
  remarkText: PropTypes.string,
  setSaveClicked: PropTypes.func,
  formConfig: PropTypes.object,
  saveClicked: PropTypes.bool,
  setIsRejectPopupOpen: PropTypes.func,
  handleBackButtonFunction: PropTypes.func,
  setIsOverlayLoader: PropTypes.func,
  isValideValue: PropTypes.bool,
};

export default InternalCertificateButtons;